import React, { useRef, useState } from 'react';
import SyncMobileDevicesModal from '../ControlPanel/SyncMobileDevices/SyncMobileDevicesModal/index';
import { Box, CardMedia, FilledInput, IconButton, Typography } from '@mui/material';
import Premium from '../../../assets/images/PRO logo PMS green only.svg';
import styles from './styles';
import { FileOpen } from '@mui/icons-material';
import PropTypes from 'prop-types';
import PartsPriceUpdatePreview from '../PartsPriceUpdatePreview';

function PartsPriceUpdateDialog({ open, handleClose, isLoading, handleUpload, showDateTimeRange, showCta2, hideLimit }) {
  const classes = styles();

  const [selectedFile, setSelectedFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [custom2, setCustom2] = useState(0);
  const [error, setError] = useState(null);
  const dropAreaRef = useRef(null);
  const fileInputRef = useRef(null);
  const [partsPriceUpdatePreview, setPartsPriceUpdatePreview] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'text/csv') {
      setSelectedFile(file);
      setError(null);
    } else {
      setSelectedFile(null);
      setError('Only .csv files are allowed');
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type === 'text/csv') {
      setSelectedFile(file);
      setError(null);
    } else {
      setSelectedFile(null);
      setError('Only .csv files are allowed');
    }
    e.dataTransfer.clearData();
  };

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const handleFileUpload = () => {
    if (!selectedFile) {
      setError('Select a csv file to upload');
      return;
    }
    handleUpload(selectedFile, custom2);
  };

  return (
    <div>
      <SyncMobileDevicesModal
        open={open}
        onClose={handleClose}
        handleClose={handleClose}
        cta2Label={'Preview'}
        cta2Action={() => {
          setPartsPriceUpdatePreview(true);
        }}
        showCta2={showCta2}
        showDateTimeRange={showDateTimeRange}
        cta2Disabled={isLoading || !selectedFile || !custom2}
      >
        <CardMedia
          component="img"
          image={Premium}
          className={classes.logo}
        />
        <Typography variant="h4" gutterBottom component="div" style={{ textAlign: 'center' }}>
          {isLoading ? 'Uploading...' : 'Add or select media'}
        </Typography>
        <Box
          className={isDragging ? classes.dragDrop : classes.dropArea}
          ref={dropAreaRef}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <input
            type="file"
            onChange={handleFileChange}
            style={{ display: 'none' }}
            id="fileInput"
            ref={fileInputRef}
          />
          <label htmlFor="fileInput" style={{ cursor: 'pointer' }}>
            Drop files here to upload them or press button
            <br />
            <br />
            <IconButton
              edge="end"
              sx={{ marginRight: '1%' }}
              onClick={handleIconClick}
            >
              <FileOpen />
           </IconButton>
          </label>
        </Box>
        {error && <Box className={classes.errorMessage}>{error}</Box>}
        {selectedFile && <Box className={classes.selectedFileMessage}>Selected file: {selectedFile.name}</Box>}
        <p className={classes.fileDescription}>
          Allowed file upload: <strong>one file only</strong>
          {!hideLimit && <> <br />File must be less than <strong>2 MB</strong></>}
          <br />
          Allowed file types: <strong>csv</strong>
        </p>
        <Box display={'flex'} alignItems={'center'}>
        <Typography sx={{ mr: 1, fontSize: '16px' }}>Custom 2</Typography>
        <FilledInput
          type="number"
          label="Custom 2"
          value={custom2}
          onChange={(e) => {
            setCustom2(e.target.value);
          }}
          inputProps={{ style: { fontSize: 18, margin: 0, padding: 4, textAlign: 'center' } }}
          sx={{
            width: '100px',
            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
              display: 'none',
            },
            '& input[type=number]': {
              MozAppearance: 'textfield',
            },
          }}
        />
      </Box>
      </SyncMobileDevicesModal>
      {partsPriceUpdatePreview && selectedFile && (
          <PartsPriceUpdatePreview
          open={partsPriceUpdatePreview}
          handleClose={() => {
            setPartsPriceUpdatePreview(false);
          }}
          isLoading={isLoading}
          handleUpload={handleFileUpload}
          selectedFile={selectedFile}
          custom2={custom2}
        />
      )}
    </div>
  );
}

PartsPriceUpdateDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  isLoading: PropTypes.bool,
  handleUpload: PropTypes.func,
  showDateTimeRange: PropTypes.bool,
  showCta2: PropTypes.bool,
  hideLimit: PropTypes.bool
};

PartsPriceUpdateDialog.defaultProps = {
  open: false,
  showDateTimeRange: false,
  showCta2: true,
  isLoading: false,
  hideLimit: false
};

export default PartsPriceUpdateDialog;
